import { checkActionCode, getAuth } from "firebase/auth";
import {
  child, equalTo, get, getDatabase, orderByChild, push, query, ref,
  // onValue,
  remove, set, update
} from "firebase/database";
import { useLocalObservable } from "mobx-react-lite";
import { updateCoEditDoc } from "../services/MilestoneService";
import StoreAction from "./StoreAction";

const initialState = {
  visible: false,
  member: "",
  deadline: new Date(),
  scope: "",
  assignmentList: [],
  myPosition: "",
  teamId: "",
  docUrl: "",
  textContent: "<p></p>",
  hasCEO: false,
  chapter: "",
  companyUrl: "",
  progressList: [],
  docUrlKey: "",
  companyUrlKey: "",
  fetching: false,
};

const MilestoneStore = () => {
  const dbRef = ref(getDatabase());
  const db = getDatabase();
  const auth = getAuth();
  const store = useLocalObservable(() => ({
    /*observables*/
    ...initialState,
    ...StoreAction(initialState),

    createNewDoc(data) {
      push(child(dbRef, "coEditDoc"), data);
    },
    createNewTask() {
      const { scope, deadline, member, chapter, teamId } = this;

      push(child(dbRef, "tasks"), {
        scope,
        deadline: deadline.toISOString(),
        member,
        complete: false,
        chapter,
        teamId,
      });

      this.closeModal();
      this.member = "";
      this.scope = "";
      this.deadline = new Date();
      this.getTaskList();
    },
    async deleteTask(key) {
      await remove(child(dbRef, `tasks/${key}`));
      this.getTaskList();
    },
    async getTaskList() {
      const tasks = await get(
        query(ref(db, "tasks"), orderByChild("teamId"), equalTo(this.teamId))
      );

      if (tasks.val()) {
        this.assignmentList = Object.values(tasks.val()).filter(
          (item, index) => {
            item.deadline = new Date(item.deadline);
            item.key = Object.keys(tasks.val())[index];
            return item.chapter === this.chapter;
          }
        );
      } else {
        this.assignmentList = [];
      }
    },
    async updateTask(key, complete) {
      await update(ref(db, `tasks/${key}`), {
        complete,
      });
      this.getTaskList();
    },
    async setCompanyUrl() {
      if (this.companyUrlKey) {
        await update(child(dbRef, `companyUrl/${this.companyUrlKey}`), {
          url: this.companyUrl,
        });
      } else if (this.teamId) {
        this.companyUrlKey = await push(child(dbRef, "companyUrl"), {
          url: this.companyUrl,
          chapter: "10",
          teamId: this.teamId,
        }).key;
      }
    },
    async setTextContent(chapter, content, docKey) {
      if (docKey) {
        updateCoEditDoc(docKey, content);
      } else if (this.teamId) {
        this.docUrlKey = await push(child(dbRef, "coEditDoc"), {
          chapter: chapter,
          teamId: this.teamId,
          textContent: content,
        }).key;
        await push(child(dbRef, `teams/${this.teamId}/coEditDoc`), { chapter: chapter, docKey: this.docUrlKey });
      }
    },
    async getTeamId(uid) {
      this.fetching = true;
      let currentUser = (await get(child(dbRef, `users/${uid}`))).val();
      if (currentUser) this.teamId = currentUser.teamId;
      this.fetching = false;
    },
    async checkCEO(uid) {
      const teamsRef = ref(db, "teams");
      let currentUser = (await get(child(dbRef, `users/${uid}`))).val();
      if (currentUser) {
        let teamsSnap = await get(child(teamsRef, `${currentUser.teamId}`));
        let team = teamsSnap.val();
        if (team) {
          let teamMembers = team.members;
          for (const memberId in teamMembers) {
            if (teamMembers[memberId].title === "CEO") {
              this.hasCEO = true;
            };
          }
        }
      }
    },
    async init(uid) {
      console.log("hello")
      const teamsRef = ref(db, "teams");
      let currentUser = (await get(child(dbRef, `users/${uid}`))).val();
      let teamsSnap = await get(child(teamsRef, `${currentUser.teamId}`));
      this.myPosition = teamsSnap.val().members[uid].title;
      this.teamId = currentUser.teamId;
      this.getTaskList();

      const docData = await get(
        query(
          ref(db, "coEditDoc"),
          orderByChild("teamId"),
          equalTo(currentUser.teamId)
        )
      );
      console.log(docData.val())
      if (docData.val()) {
        const currentDoc = Object.values(docData.val()).find(
          (item) => item.chapter === this.chapter
        );
        if (currentDoc) {
          // Initialize "textContent" if data exist but does not have the key
          if (!("textContent" in currentDoc)) {
            let key = Object.keys(docData.val()).find(key => docData.val()[key].chapter === this.chapter);
            let textRef = child(ref(db, "coEditDoc"), key);
            set(child(textRef, "textContent"), "<p></p>")
          }
          this.textContent = currentDoc.textContent;
          this.docUrl = currentDoc.url;
          this.docUrlKey = Object.keys(docData.val())[0];
          console.log(this.docUrlKey);
        }
      }

      const companyUrlData = await get(
        query(
          ref(db, "companyUrl"),
          orderByChild("teamId"),
          equalTo(currentUser.teamId)
        )
      );
      if (companyUrlData.val()) {
        const currentCompanyUrl = Object.values(companyUrlData.val()).find(
          (item) => item.chapter === this.chapter
        );
        if (currentCompanyUrl) {
          this.companyUrl = currentCompanyUrl.url;
          this.companyUrlKey = Object.keys(companyUrlData)[0];
        }
      }
    },

    async getProgress(uid) {
      let currentUser = (await get(child(dbRef, `users/${uid}`))).val();
      this.teamId = currentUser.teamId;
      const docData = await get(
        query(
          ref(db, "coEditDoc"),
          orderByChild("teamId"),
          equalTo(currentUser.teamId)
        )
      );
      const tasks = await get(
        query(
          ref(db, "tasks"),
          orderByChild("teamId"),
          equalTo(currentUser.teamId)
        )
      );
      const companyUrl = await get(
        query(
          ref(db, "companyUrl"),
          orderByChild("teamId"),
          equalTo(currentUser.teamId)
        )
      );

      this.progressList = Array.from(Array(11).keys()).map((key) => {
        return {
          docUrl: Object.values(docData.val() || {}).find(
            (item) => item.chapter === key.toString()
          ),
          textContent: Object.values(docData.val() || {}).find(
            (item) => item.chapter === key.toString()
          ),
          task: Object.values(tasks.val() || {}).find(
            (item) => item.chapter === key.toString()
          ),
          companyUrl: Object.values(companyUrl.val() || {}).find(
            (item) => item.chapter === key.toString()
          ),
        };
      });
    },
  }));

  return store;
};

export default MilestoneStore;
